import { Navbar } from "../components/Navbar";
import { useAuth } from "../context/AuthContext";
import { Badge } from "../components/ui/badge";
import { PostedJobsManager } from "../components/PostedJobsManager";
import { AlertTriangle } from "lucide-react";

export default function CompanyDashboard() {
  const { user } = useAuth();
  const approved = user.status === "approved";

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="border-b border-foreground bg-foreground text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8 flex items-center justify-between gap-3 flex-wrap">
          <div>
            <span className="label-caps text-accent">Company console</span>
            <h1 className="font-display font-black text-3xl tracking-tight mt-1">{user.company_name || user.name}</h1>
          </div>
          <Badge className={`rounded-none uppercase tracking-wider ${approved ? "bg-accent text-foreground" : "bg-white/20 text-white"}`} data-testid="company-status">{user.status}</Badge>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
        {!approved && (
          <div className="border border-accent bg-accent/10 p-4 flex items-start gap-3 mb-6" data-testid="pending-banner">
            <AlertTriangle className="h-5 w-5 text-foreground shrink-0 mt-0.5" />
            <div>
              <p className="font-medium">Your company account is pending approval</p>
              <p className="text-sm text-muted-foreground">Once an admin approves you, you can post transport jobs and receive quotes from verified drivers.</p>
            </div>
          </div>
        )}
        <h2 className="font-display font-bold text-xl tracking-tight mb-4">Your transport jobs</h2>
        <PostedJobsManager disabled={!approved} />
      </div>
    </div>
  );
}
